// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  name: __t.string(),
  description: __t.string(),
  width: __t.u32(),
  height: __t.u32(),
  fps: __t.f64(),
  sampleRate: __t.u32().name("sample_rate"),
  backgroundColor: __t.string().name("background_color"),
  durationUs: __t.f64().name("duration_us"),
  posterAssetId: __t.string().name("poster_asset_id"),
  createdByUserId: __t.string().name("created_by_user_id"),
  createdByName: __t.string().name("created_by_name"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  updatedByName: __t.string().name("updated_by_name"),
  archived: __t.bool(),
  reviewStatus: __t.string().name("review_status"),
  reviewRound: __t.u32().name("review_round"),
  reviewRequestedByName: __t.string().name("review_requested_by_name"),
  reviewNote: __t.string().name("review_note"),
  template: __t.bool(),
  lastOpenedAt: __t.option(__t.timestamp()).name("last_opened_at"),
  reviewVersionId: __t.string().name("review_version_id"),
  spaceId: __t.string().name("space_id"),
  folderId: __t.string().name("folder_id"),
  scopeId: __t.string().name("scope_id"),
  reviewRequestedByUserId: __t.string().name("review_requested_by_user_id"),
  mediaAssetIds: __t.string().name("media_asset_ids"),
  colorSpace: __t.string().name("color_space"),
  workingSpace: __t.string().name("working_space"),
});
